import React, { useState } from 'react';
import { es } from 'date-fns/locale';
import { CalendarDays } from 'lucide-react';
import { Calendar } from '../../../components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/ui/popover';
import { Button } from '../../../components/ui/button';

const aDate = (iso) => (iso ? new Date(`${iso}T12:00:00`) : undefined);
const aIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// Selector de fecha dd/mm/aaaa (valor 'AAAA-MM-DD').
export const FechaPicker = ({ value, onChange, min, max, placeholder = 'dd/mm/aaaa', testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="h-9 w-36 justify-start gap-2 px-3 font-normal" data-testid={testId}>
          <CalendarDays className="h-4 w-4 text-slate-400" />
          {value ? value.split('-').reverse().join('/') : <span className="text-slate-400">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={es} selected={aDate(value)} defaultMonth={aDate(value)}
          disabled={[...(min ? [{ before: aDate(min) }] : []), ...(max ? [{ after: aDate(max) }] : [])]}
          onSelect={(d) => { if (d) { onChange(aIso(d)); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
